import messages_mx from './translations/es-MX.json';
import messages_es from './translations/en-MX.json';

/// Messages
export const messages = {
  'es-MX': messages_mx,
  'en-MX': messages_es
}


export const ENUM_RECOMENDATIONS = {
  'IFEfront'    : 0,
  'IFEreverse'  : 1,
  'curp'        : 4,
  'selfie'      : 2,
  'proofadress' : 3
}

export const ENUM_TYPEDOCUMENT = {
  'ifeFront'   : 0,
  'ifeBack'    : 1,
  'curp'       : 2,
  'selfie'     : 3,
  'proofAdress': 4
}

export const ENUM_KEYACT = {
  'documents'   : 0,
  'selfie'      : 1,
  'proofAdress' : 3
}

export const ENUM_DISPLAY = {
  ''       : "hidden",
  'false'  : "hidden",
  'preview': "flex",
  'alert'  : "hidden"
}

export const ENUM_NEXT_VIEW = {
  0: 'selfie',
  1: 'proofAdress',
  2: 'contact',
  3: 'finishSuccess'
}

export const STYLES_BUTTONS_TEXT_COLOR = {
  'false': 'blanco',
  'true':  'bajio60'
}

export const STYLES_BUTTONS_BACKCOLOR = {
  'false': 'primarymeta',
  'true':  'bajio40'
}

export const BORDER_DOCUMENTS = {
  'required': "irapuato"
}

export const COLOR_MESSAGES = {
  "warning" : "bg-tucul",
  "success" : "bg-guanajuatop",
  "error"   : "bg-irapuatop"
}

export const CATALOG_ERRORS = {
  'required'             : true,
  'badPhoneMain'         : true,
  'cellMPhoneNAceptable' : true,
  'lessPhoneMain'        : true,
  'badPhoneSecondary'    : true,
  'cellSPhoneNAceptable' : true,
  'lessPhoneSecondary'   : true,
  'badEmail'             : true
}

export const CATALOG_ERRORS_IDS = {
  'required'             : 'outlined-error',
  'badPhoneMain'         : 'outlined-error',
  'cellMPhoneNAceptable' : 'outlined-error',
  'lessPhoneMain'        : 'outlined-error',
  'badPhoneSecondary'    : 'outlined-error',
  'cellSPhoneNAceptable' : 'outlined-error',
  'lessPhoneSecondary'   : 'outlined-error',
  'badEmail'             : 'outlined-error',
}

export const PORCENT_STEPS_ACTOS = {
  "documents"   : "25%",
  "selfie"      : "50%",
  "proofAdress" : "75%",
  "contact"     : "100%"
}

export const STEPS_ACTOS = {
  "documents"   : "1",
  "selfie"      : "2",
  "general"     : "3",
  "proofAdress" : "3",
  "adress"      : "5",
  "contact"     : "4"
}

export const STYLE_PROGRESS = {
  "recomendation": "hidden",
  "documents"    : "w-full h-10 bg-blanco",
  "selfie"       : "w-full h-10 bg-blanco",
  "proofAdress"  : "w-full h-10 bg-blanco",
  "adress"       : "w-full h-10 bg-blanco",
  "contact"      : "w-full h-10 bg-blanco"
}

export const ERRORS_SELFIE = {
  "noDataBase"   : "No se encontro la INE/IFE para validar con la fotografía",
  "different"    : "No son la misma persona",
  "noDetected"   : "La fotografía no contiene un rostro, por favor toma nuevamente la fotografía",
  "moreDetected" : "La fotografía contiene mas de un rostro",
  "errorService" : "Estamos presentando problemas, por favor contacta a soporte",
  "errorService" : "Estamos presentando problemas, por favor contacta a soporte",
  "errorFound"   : "No se encontro la INE/IFE para validar con la fotografía",
  "detected"     : "Hemos detectado el rostro del prospecto correctamente",
  "same"         : "Hemos detectado el rostro del prospecto correctamente"
};

export const ERRORS_BORDERBG = {
  "noDataBase"   : "border-warning bg-tucul",
  "different"    : "border-warning bg-tucul",
  "noDetected"   : "border-warning bg-tucul",
  "moreDetected" : "border-warning bg-tucul",
  "errorService" : "border-warning bg-tucul",
  "errorFound"   : "border-warning bg-tucul",
  "detected"     : "border-success bg-guanajuatop",
  "same"         : "border-success bg-guanajuatop"
};

export const ERROR_STATUS = {
  500  : "error_server",
  2136 : "error_network",
  404  : "error_notFound",
  409  : "error_conflict"
}

export const DESCRIPTION_NOTAS = {
  'manFINE' : "Necesitamos una fotografía de la INE/IFE del prospecto",
  'manRINE' : "Si tienes problemas con la toma de la INE/IFE revisa los siguientes puntos:",
  'manDOMC' : "Necesitamos que le tomes una foto al comprobante del prospecto"
}

export const DESCRIPTION_NOTAS_R ={
  'recomendDocuments' : "Necesitamos una fotografía de la INE/IFE del prospecto",
  'recomendSelfie'    : "Necesitamos que le tomes una foto del rostro (selfie) al prospecto",
  'recomendDomicilio' : "Necesitamos que le tomes una foto al comprobante del prospecto"
}

export const ENUM_SEXO = {
  "M": "F",
  "H": "H"
}


export const NUM_VIEW_ANDROID = {
  "documents": 1,
  "general":   5,
  "imgdoc":    6,
  "selfie":    3,
  "domicilio": 7,
  "contact":   8
}

export const STYLES_MESSAGE_DOCUMENTS = {
  "badCurp"            : "m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "noDataIne"          : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "ncoincideCURP"      : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "takeFotoAgain"      : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "errorOCRCURP"       : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "PersonNotSame"      : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "errorVigence"       : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "errorVigence"       : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "errorVigence"       : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "errorBackList"      : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "errorGender"        : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "errorExisteCURP"    : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "errorCargaINE"      : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "takeTFoto"          : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "takeFoto"           : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "errorRed"           : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "badCurpNobarium"    : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "errorAgeMax"        : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "errorIFEIncorrect"  : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "CURPINCORRECTO"     : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "errorCNBVCURP"      : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "dataIne"            : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-success bg-guanajuatop",
  "dataIneV"           : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-warning bg-tucul",
  "sameIFE"            : "flex items-center m-auto sm:mt-12 md:mt-16 xl:mt-16 xl2:mt-16 xl3:mt-16 ml-3 mr-3 mb-5 sm:h-auto md:h-20 xl:h-20 xl2:h-20 xl3:h-20 p-3 rounded-boxer border-success bg-guanajuatop"
}

export const ICON_MESSAGE = {
  "badCurp"           : "exclamation",
  "noDataIne"         : "exclamation",
  "takeFotoAgain"     : "exclamation",
  "ncoincideCURP"     : "exclamation",
  "errorOCRCURP"      : "exclamation",
  "PersonNotSame"     : "exclamation",
  "errorVigence"      : "exclamation",
  "errorBackList"     : "exclamation",
  "errorGender"       : "exclamation",
  "errorExisteCURP"   : "exclamation",
  "errorCargaINE"     : "exclamation",
  "takeTFoto"         : "exclamation",
  "takeFoto"          : "exclamation",
  "errorRed"          : "exclamation",
  "badCurpNobarium"   : "exclamation",
  "errorAgeMax"       : "exclamation",
  "errorIFEIncorrect" : "exclamation",
  "CURPINCORRECTO"    : "exclamation",
  "CURPCorrecto"      : "exclamation",
  "errorCNBVCURP"     : "exclamation",
  "dataIne"           : "success",
  "dataIneV"          : "exclamation",
  "sameIFE"           : "success"
}

export const MESSAGES_DOCUMENTS = {
  "noDataIne"          : "No pudimos obtener la información de la INE/IFE del cliente",
  "CURPINCORRECTO"     : "Al validar la CURP del cliente en RENAPO no existe",
  "ncoincideCURP"      : "Al validar la CURP del cliente INE/IFE, no se encontro en RENAPO. Por favor captura tu CURP",
  "badCurp"            : "Por favor validar el formato de CURP del cliente",
  "takeFotoAgain"      : "La IFE/INE del cliente no es correcta o la imagen no es muy clara, porfavor intenta tomarlas nuevamente",
  "dataIne"            : "Se obtuvieron los datos de la INE/IFE",
  "dataIneV"           : "Verifica que la INE/IFE tenga una vigencia  válida o no cuente con trámites posteriores",
  "CURPCorrecto"       : "El CURP obtenido es válido para la INE/IFE",
  "CURPCorrectoV"      : "Verifica que la INE/IFE tenga una vigencia  válida o no cuente con trámites posteriores",
  "errorOCRCURP"       : "Por favor, asegúrate que la imagen es clara y se encuentra orientada correctamente. También puedes ingresar la CURP del cliente manualmente",
  "PersonNotSame"      : "Los datos obtenidos de la CURP del cliente no son los mismos obtenidos de la INE/IFE",
  "errorVigence"       : "Tu INE/IFE del cliente no esta vigente como medio de identificacion y no puedes votar",
  "errorBackList"      : "Cliente no apto para crédito. No cumple con los requisitos para poder continuar con el proceso",
  "errorGender"        : "El género no es elegible para solicitar el crédito",
  "errorExisteCURP"    : "Los datos ya se encuentran registrados",
  "takeTFoto"          : "Por favor toma nuevamente las fotografías del INE/IFE",
  "takeFoto"           : "Por favor toma nuevamente las fotografías del INE/IFE",
  "errorRed"           : "No se ha podido enviar la información. Comprueba la red e inténtalo de nuevo",
  "errorCargaINE"      : "",
  "badCurpNobarium"    : "El CURP que obtuvimos de la INE/IFE no tiene el formato correcto",
  "errorAgeMax"        : "La edad del cliente no es elegible para continuar",
  "errorIFEIncorrect"  : "El documento que intentas cargar no corresponde a los datos proporcionados",
  "requiredDocuments"  : "Para poder avanzar, se requiere completar toda la información",
  "incorrectDocuments" : "El CURP no es correcto o válido, no coincide con el de la INE/IFE del cliente",
  "errorSaveDocuments" : "Por favor itenta enviar la información nuevamente",
  "errorCNBVCURP"      : "El CURP se encuentra en la lista de CNBV",
  "sameIFE"            : "El documento corresponde a los datos proporcionados"
}


const API_DIGITALONBOARDING_CREDIT = {
  DEVELOP :    "https://dev.ms.sandbox-metafinanciera.com/digitalonboarding/processV2",
  QA:          "https://qa.ms.sandbox-metafinanciera.com/digitalonboarding/processV2",
  PRODUCCION:  "https://prod.ms.sandbox-metafinanciera.com/digitalonboarding/processV2",
}

const SERVER_DIGITALONBOARDING         = API_DIGITALONBOARDING_CREDIT['DEVELOP'];


export const CLAVE_APIKEY_SIM          = process.env.REACT_APP_APIKEY;

export const BASE_URL_SERVER           = process.env.REACT_APP_URL_BASE;

/// API FACEREGONITATION
export const OCR_CURP                  = `${process.env.REACT_APP_URL_FACECOGNITATION}/ocr/curpV2`;
export const OCR_ADRESS                = `${process.env.REACT_APP_URL_FACECOGNITATION}/ocr/comprobanteDomicilioV2`;
export const SELFIE_API                = `${process.env.REACT_APP_URL_FACECOGNITATION}/faceRecognitionV2`;
export const VALIDATE_IS_SELFIE        = `${process.env.REACT_APP_URL_FACECOGNITATION}/findRostroBase64`;
export const API_ALTERNATIVE_ADRESS    = `${process.env.REACT_APP_URL_FACECOGNITATION}/getAdreesFromNubarium`;
export const VALIDATE_CODEPOSTAL       = `${process.env.REACT_APP_URL_FACECOGNITATION}/codePostal`;
export const VALIDATE_INEFRONTAL       = `${process.env.REACT_APP_URL_FACECOGNITATION}/ocr/curpINE`;

/// API NOBARIUM
export const GET_DATA_INE_NU           =  `${process.env.REACT_APP_URL_PROCCESSMETADATA}/obtainINEDataNubarium`//`${process.env.REACT_APP_URL_PROCCESSMETADATA}/getIdDataNubarium`;
export const VALIDATE_VIGENCE_NU       = `${process.env.REACT_APP_URL_PROCCESSMETADATA}/validateINENubarium`;
export const BLACKLIST_ORIG            = `${process.env.REACT_APP_URL_ORIGINCREDIT}/validaListaNegraNew`;
export const VALIDATE_BUNISESS_RULES   = `${process.env.REACT_APP_URL_PROCCESSMETADATA}/validateBusinessRule`;
export const VALIDATE_CURP_NU          = `${process.env.REACT_APP_URL_PROCCESSMETADATA}/v3/validateCurpFromNubarium`;

/// API DIGITAL ONBOARDING
export const SAVE_IMAGES               = `${SERVER_DIGITALONBOARDING}/upload`;